import { Droplets, Sparkles } from "lucide-react";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-sky-50 via-white to-blue-100">
      {/* Background decorations */}
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-sky-200/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-blue-200/30 blur-3xl" />

      <div className="relative flex flex-col items-center px-6">
        {/* Brand icon and washing machine */}
        <div className="relative mb-8">
          {/* Outer rotating ring */}
          <div className="absolute -inset-4 rounded-[2rem] border-2 border-dashed border-sky-200 animate-[spin_12s_linear_infinite]" />

          {/* Washing machine */}
          <div className="relative flex h-32 w-32 flex-col overflow-hidden rounded-[1.75rem] border border-white bg-white shadow-xl shadow-blue-200/60">
            {/* Machine top panel */}
            <div className="flex h-8 items-center justify-between border-b border-sky-100 bg-gradient-to-r from-sky-500 to-blue-600 px-3">
              <div className="flex items-center gap-1">
                <span className="h-1.5 w-1.5 rounded-full bg-white/90" />
                <span className="h-1.5 w-1.5 rounded-full bg-white/60" />
              </div>

              <div className="flex items-center gap-1 rounded-full bg-white/20 px-2 py-0.5">
                <Sparkles size={10} className="text-white" />
                <span className="text-[8px] font-bold tracking-widest text-white">
                  WASH
                </span>
              </div>
            </div>

            {/* Machine door */}
            <div className="flex flex-1 items-center justify-center bg-gradient-to-b from-slate-50 to-sky-50">
              <div className="relative flex h-[4.5rem] w-[4.5rem] items-center justify-center overflow-hidden rounded-full border-[5px] border-slate-200 bg-gradient-to-br from-sky-100 to-blue-200 shadow-inner">
                {/* Water inside the drum */}
                <div className="absolute inset-1 overflow-hidden rounded-full bg-gradient-to-b from-sky-200 to-blue-500">
                  <div className="absolute -left-3 top-5 h-16 w-20 rounded-[45%] bg-sky-300/80 animate-[spin_3s_linear_infinite]" />

                  <div className="absolute -right-3 top-3 h-14 w-14 rounded-full bg-blue-400/80 animate-[spin_2s_linear_infinite]" />

                  {/* Bubbles */}
                  <span className="absolute left-3 top-2 h-2 w-2 animate-bounce rounded-full bg-white/90" />
                  <span className="absolute right-3 top-5 h-1.5 w-1.5 animate-pulse rounded-full bg-white/80" />
                  <span className="absolute bottom-3 left-5 h-1.5 w-1.5 animate-ping rounded-full bg-white/70" />
                </div>

                {/* Drum highlight */}
                <div className="absolute left-2 top-2 h-3 w-5 rotate-[-35deg] rounded-full bg-white/50 blur-[1px]" />
              </div>
            </div>
          </div>

          {/* Floating water droplets */}
          <Droplets
            size={20}
            className="absolute -right-7 top-2 animate-bounce text-sky-500"
          />

          <Sparkles
            size={17}
            className="absolute -left-7 bottom-4 animate-pulse text-blue-400"
          />

          <span className="absolute -right-3 -bottom-3 h-3 w-3 animate-ping rounded-full bg-sky-400/60" />
        </div>

        {/* Loading text */}
        <div className="text-center">
          <h2 className="text-xl font-bold tracking-tight text-slate-800">
            Freshening things up
            <span className="inline-flex w-6 text-left">
              <span className="animate-pulse">...</span>
            </span>
          </h2>

          <p className="mt-2 text-sm text-slate-500">
            Preparing your laundry dashboard
          </p>
        </div>

        {/* Animated progress indicator */}
        <div className="mt-6 h-1.5 w-48 overflow-hidden rounded-full bg-sky-100">
          <div className="h-full w-1/2 rounded-full bg-gradient-to-r from-sky-400 via-blue-500 to-indigo-500 animate-[loading_1.6s_ease-in-out_infinite]" />
        </div>

        <p className="mt-4 text-[11px] font-medium uppercase tracking-[0.2em] text-slate-400">
          Clean clothes. Fresh start.
        </p>
      </div>

      {/* Progress animation */}
      <style>{`
        @keyframes loading {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(200%);
          }
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
